import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import AssignmentFullDetailed from './AssignmentFullDetailed';

const AssignmentFullDetailedWrapper = props => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
  });
  return (
    <AssignmentFullDetailed
      {...props}
      printRef={contentRef}
      handlePrint={handlePrint}
    />
  );
};

export default AssignmentFullDetailedWrapper;
